import { add, sub } from 'date-fns';

import { AGGREGATED_FILTER_FIELDS } from '@spa/shared/constants/aggregatedFilterFieldsValue';
import { DATE_FORMAT_SHORT_MONTH } from '@spa/shared/utils/transformers/contracts';
import { formatDate } from '@spa/shared/utils/date';

// Counts the aggregated filter fields that have more than one value for a single filter field
const FLEX_MOVE_IN_FILTER = 'flex-move-in';

export const countAggregatedFilters = (fields, filter) => {
  const aggregatedKeys = AGGREGATED_FILTER_FIELDS[filter];
  const field = fields[filter];

  if (filter === FLEX_MOVE_IN_FILTER) {
    return 1;
  }

  if (aggregatedKeys === undefined) {
    return field.length;
  }

  return Object.keys(aggregatedKeys).reduce(
    (acc, key) => (field.find(value => value === key) ? acc + aggregatedKeys[key] : acc),
    0
  );
};

export const transformFlexMoveIn = (t, flexMoveInQuery, language, isInResidencesSearch) => {
  if (!flexMoveInQuery) {
    return '';
  }

  if (typeof flexMoveInQuery === 'string') {
    const prefix = !isInResidencesSearch ? `${t('filters.labels.flexible')} | ` : '';

    return `${prefix}${formatDate(new Date(flexMoveInQuery), language, DATE_FORMAT_SHORT_MONTH)}`;
  }

  const sortedflexMoveInQuery = flexMoveInQuery.sort((a, b) => new Date(a) - new Date(b));

  return sortedflexMoveInQuery.reduce(
    (acc, flexString, index) => {
      const monthDate = formatDate(new Date(flexString), language, DATE_FORMAT_SHORT_MONTH);

      if (acc.visited.includes(monthDate)) {
        return acc;
      }

      const group_by = 3;
      const comma = index !== 0 ? ',' : '';
      const isRestOfArrayGroupable = flexMoveInQuery.length >= index + group_by;

      if (isRestOfArrayGroupable) {
        const numberOfConsecutiveMonths = flexMoveInQuery.reduce(
          (acc, _, i) => {
            const currentIndex = index + i;

            if ((acc.emptySpace && acc.sum) || currentIndex >= flexMoveInQuery.length) {
              return acc;
            }

            const monthDateSubtractedByIndex = formatDate(
              sub(new Date(flexMoveInQuery[currentIndex]), { months: i }),
              language,
              DATE_FORMAT_SHORT_MONTH
            );

            if (monthDateSubtractedByIndex === monthDate) {
              return { sum: acc.sum + 1, emptySpace: false };
            }

            return { sum: acc.sum, emptySpace: true };
          },
          { sum: 0, emptySpace: false }
        ).sum;

        if (numberOfConsecutiveMonths >= group_by) {
          const nextDate = formatDate(
            add(new Date(flexString), { months: numberOfConsecutiveMonths - 1 }),
            language,
            DATE_FORMAT_SHORT_MONTH
          );
          const visitedMonthsArray = Array.from(new Array(numberOfConsecutiveMonths)).map((_, i) =>
            formatDate(add(new Date(flexString), { months: i }), language, DATE_FORMAT_SHORT_MONTH)
          );

          return {
            flexMoveInString: `${acc.flexMoveInString}${comma} ${monthDate} ${t('global.labels.to')} ${nextDate}`,
            visited: [...acc.visited, ...visitedMonthsArray]
          };
        }
      }

      return {
        flexMoveInString: `${acc.flexMoveInString}${comma} ${monthDate}`,
        visited: [...acc.visited, monthDate]
      };
    },
    {
      flexMoveInString: !isInResidencesSearch ? `${t('filters.labels.flexible')} |` : '',
      visited: []
    }
  ).flexMoveInString;
};
